import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "no-tabs sent-geo-modal" }
const _hoisted_2 = { class: "d-flex flex-column align-items-center justify-content-center mt-5" }
const _hoisted_3 = {
  for: "module-select",
  class: "form-label"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "container-fluid mt-10" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-sm-6 mx-auto" }
const _hoisted_8 = { class: "col-12 col-sm-6 mx-auto" }
const _hoisted_9 = { class: "me-2" }
const _hoisted_10 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxMasterDetail = _resolveComponent("DxMasterDetail")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('modules.forms.select_form')) + ":", 1),
      _createVNode(_component_vue_select, {
        modelValue: _ctx.selectedValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
        options: _ctx.formsList,
        class: "flex-grow vue-select",
        icon: "bi bi-ui-checks",
        label: "name",
        onUpdateSelect: _ctx.getForm
      }, null, 8, ["modelValue", "options", "onUpdateSelect"]),
      _createElementVNode("button", {
        class: "btn btn-primary mt-5",
        disabled: !_ctx.selectedValue,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToModule && _ctx.navigateToModule(...args)))
      }, _toDisplayString(_ctx.$t('modules.forms.next')), 9, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('modules.forms.form_history_head')), 1)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clearfix" }, null, -1)),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_DxDataGrid, {
            "data-source": _ctx.dataSource,
            "key-expr": "key",
            "show-borders": true
          }, {
            "master-detail": _withCtx(({ data }) => [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('modules.forms.form_history_table_head')) + ": ", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.details, (detail, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "list-group-item d-flex justify-content-between align-items-start small"
                  }, [
                    _createElementVNode("strong", _hoisted_9, _toDisplayString(detail.fieldName) + ":", 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(detail.value), 1)
                  ]))
                }), 128))
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "formName",
                caption: _ctx.$t('modules.forms.list.form')
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                "data-field": "createdAt",
                caption: _ctx.$t('modules.forms.list.createdAt'),
                "data-type": "date",
                format: "yyyy-MM-dd HH:mm:ss"
              }, null, 8, ["caption"]),
              _createVNode(_component_DxMasterDetail, {
                enabled: true,
                template: "master-detail"
              })
            ]),
            _: 1
          }, 8, ["data-source"])
        ])
      ])
    ])
  ]))
}